import { render, staticRenderFns } from "./ImportantFeedbackItem.vue?vue&type=template&id=7cc2ed5c&"
import script from "./ImportantFeedbackItem.vue?vue&type=script&lang=js&"
export * from "./ImportantFeedbackItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports